export default function reducer(state = {
  sucursalesFP: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES_FP": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}